export const CONTENT_CODE = {
  RECEIVE_CERTIFICATE_REQUEST: 'RECEIVE_CERTIFICATE_REQUEST',
  TRANSFER_OWNERSHIP_RECIPIENT: 'TRANSFER_OWNERSHIP_RECIPIENT',
  APPROVE_CERTIFICATE_REQUEST: 'APPROVE_CERTIFICATE_REQUEST',
};
